import { makeToast } from '@cognite/cogs-lab';
import { captureException } from '@sentry/browser';
import { createContext } from 'react';

export interface UseUpsertInfieldLocationConfigMutationContextInterface {
  makeToast: typeof makeToast;
  captureException: typeof captureException;
}

export const defaultValue: UseUpsertInfieldLocationConfigMutationContextInterface =
  {
    makeToast,
    captureException,
  };

export const UseUpsertInfieldLocationConfigMutationContext =
  createContext<UseUpsertInfieldLocationConfigMutationContextInterface>(
    defaultValue
  );
